<template>
  <!--READ ONLY FIELDS-->
  <v-text-field
      v-if="field.field_type === 'read_only'"
      density="default"
      variant="underlined"
      color="primary"
      class="reg-normal mt-3"
      hide-details
      readonly
      persistent-placeholder
      v-model="new_value">
    <template #label>
      <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}</span>
    </template>
  </v-text-field>
  <!--DISABLED FIELDS-->
  <template v-else-if="isDisabled">
    <v-text-field
        v-if="field.field_type === 'link'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field' && (field.name === 'phonenumber' || field.name === 'mobilenumber')"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        placeholder="+31612345678">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'date'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        :model-value="date_display">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
<!--    <template v-else-if="field.field_type === 'text_area'">
      <span class="sm-bold text-primary">{{$store.getters.translate(field.name)}}</span><br/>
      <div v-html="new_value"/><br/>
    </template>-->
    <v-textarea
        v-else-if="field.field_type === 'text_area'"
        density="default"
        variant="underlined"
        color="primary"
        v-model="new_value"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory" ><strong>*</strong></span></span>
      </template>
    </v-textarea>
    <v-autocomplete
        v-else-if="field.field_type === 'select_single'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        :return-object="true"
        item-value="value"
        item-title="text"
        :items="$lodash.sortBy(field.available_options)">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-autocomplete>
    <v-autocomplete
        v-else-if="field.field_type === 'select_multiple'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        :return-object="false"
        item-value="value"
        item-title="text"
        :items="$lodash.sortBy(field.available_options)"
        multiple>
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-autocomplete>
    <div v-else-if="field.field_type === 'boolean'" class="mt-3" style="display: flex;">
      <template v-if="field.name === 'not_smoking'">
        <PhCigaretteSlash v-if="field.name === 'not_smoking' && new_value" color="red" size="30"/>
        <PhCigarette v-else-if="field.name === 'not_smoking'" color="green" size="30"/>
      </template>
      <template v-else>
        <PhCheck v-if="new_value" color="green" size="30"/>
        <PhX v-else color="red" size="30"/>
        <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate(field.name) }}</span>
      </template>
    </div>
  </template>
  <!--ACTIVE FIELDS-->
  <template v-else>
    <v-text-field
        v-if="field.field_type === 'link'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field' && (field.name === 'phonenumber' || field.name === 'mobilenumber')"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable
        placeholder="+31612345678">
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-menu v-else-if="field.field_type === 'date'" v-model="date_menu" :close-on-content-click="false">
      <template #activator="{ props }">
        <v-text-field
            v-bind="props"
            density="default"
            class="reg-normal text-primary mt-3"
            base-color="border-tertiary"
            bg-color="secondary"
            color="primary"
            :model-value="date_display"
            hide-details
            flat
            readonly
            clearable
            @click:clear="new_value = null">
          <template #label>
            <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
          color="primary"
          hide-header
          show-adjacent-months
          :model-value="date_value"
          @update:model-value="setDate"/>
    </v-menu>
    <v-text-field
        v-else-if="field.field_type === 'text_field'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-textarea
        v-else-if="field.field_type === 'text_area'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory" ><strong>*</strong></span></span>
      </template>
    </v-textarea>
    <v-autocomplete
        v-else-if="field.field_type === 'select_single'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        :items="$lodash.sortBy(field.available_options)"
        :return-object="true"
        item-value="value"
        item-title="text"
        hide-details
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
      <template v-if="create" #append>
        <v-icon @click.stop="createNewModel" color="primary" size="large" icon="mdi-plus"/>
      </template>
    </v-autocomplete>
    <v-autocomplete
        v-else-if="field.field_type === 'select_multiple'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        :items="$lodash.sortBy(field.available_options)"
        :return-object="false"
        item-value="value"
        item-title="text"
        chips
        closable-chips
        hide-details
        clearable
        multiple>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
      <template v-if="create" #append>
        <v-icon @click.stop="createNewModel" color="primary" size="large" icon="mdi-plus"/>
      </template>
    </v-autocomplete>
    <div v-else-if="field.field_type === 'boolean'" class="mt-3" style="display: flex;">
      <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="new_value"/>
      <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate(field.name) }}</span>
    </div>
  </template>
</template>

<script>
import {PhCheck, PhCigarette, PhCigaretteSlash, PhX} from "@phosphor-icons/vue";

export default {
  components: {PhX, PhCheck, PhCigarette, PhCigaretteSlash},
  props: ["modelValue", "field", "action", "isDisabled", "create"],
  data() {
    return {
      new_value: null,
      date_menu: false,
    };
  },
  mounted() {
    if(this.field.field_type === 'select_single') {
      this.new_value = this.field.available_options.find(option => option.value === this.modelValue);
    }
    else {
      this.new_value = this.modelValue;
    }
  },
  methods: {
    createNewModel() {
      this.$emit('create', this.field.name);
    },
    //THE MODEL KEEPS THE d-m-Y THE BACK END EXPECTS, ONLY THE FIELD SHOWS THE TEXTUAL DATE
    setDate(value) {
      this.new_value = this.moment(value).format("DD-MM-YYYY");
      this.date_menu = false;
    },
  },
  computed: {
    //THE date TYPE HOLDS BOTH d-m-Y DATES AND TIMESTAMPS, THE PICKER ITSELF ONLY WORKS WITH THE DATE PART
    date_display() {
      return this.new_value ? this.moment(this.new_value, ["DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"]).format("DD MMM YYYY") : "";
    },
    date_value() {
      return this.new_value ? this.moment(this.new_value, ["DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"]).toDate() : null;
    },
  },
  watch: {
    new_value: {
      handler() {
        let data = [];
        if(this.field.field_type === 'select_single') {
          if(this.new_value) {
            data = [this.field.name, this.new_value.value, this.new_value.text];
          }
          else {
            data = [this.field.name, null, ''];
          }
        }
        else {
          data = [this.field.name, this.new_value];
        }
        this.$emit('change', data);
      },
      deep: true
    },
    modelValue: {
      handler() {
        if(this.field.field_type === 'select_single') {
          this.new_value = this.field.available_options.find(option => option.value === this.modelValue);
        }
        else {
          this.new_value = this.modelValue;
        }
      },
      deep: true
    },
  },
};
</script>